import type { MotionProps } from 'framer-motion';
import {
  buildHiddenVariant,
  buildVisibleVariant,
} from '@/components/animations';

/*
 * Wrapper Element
 */

const WRAPPER_X_OFFSET = 50;

export const wrapperElementMotionProperties: MotionProps = {
  initial: 'hidden',
  variants: {
    hidden: buildHiddenVariant({ x: WRAPPER_X_OFFSET }),
    visible: buildVisibleVariant({
      transition: { delayChildren: 0.2, duration: 1, staggerChildren: 0.07 },
    }),
  },
  viewport: { once: true },
  whileInView: 'visible',
};
